// extracted by mini-css-extract-plugin
export default {"section":"Au-z","inSectionButton":"Bu-z","addressCard":"Cu-z","disabled":"Du-z","cautionBox":"Eu-z","failureBox":"Fu-z","fade-out":"Gu-z","successBox":"Hu-z"};